import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../../services/auth/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-herocarousel',
  templateUrl: './herocarousel.component.html',
  styleUrls: ['./herocarousel.component.scss']
})
export class HerocarouselComponent implements OnInit {

  isToggleMenuVisble = false;
  isToggleMobileMenuVisble = false;

  constructor(
    public authServe: AuthService,
    private router: Router) { }

  ngOnInit(): void {
  }



  login(event: MouseEvent): void {
    event.preventDefault();
    this.openLoginModal();
    this.toggleMenu();
  }
  toggleMenu(): void {
    this.isToggleMenuVisble = !this.isToggleMenuVisble;
  }


  signup(event: MouseEvent): void {
    event.preventDefault();
    this.openSignUpModal();
    this.toggleMenu();
  }

  openLoginModal(): void {
    this.authServe.openLoginModal();
  }

  openForgotPasswordModal(): void {
    this.authServe.openForgotPasswordModal();
  }

  openSignUpModal(): void {
    this.authServe.openSignUpModal();
  }


  logout(event: MouseEvent) {
    event.preventDefault();
    this.authServe.logout();
    this.toggleMenu();
    this.router.navigate(['/home'])
      .finally(() => {
        location.reload();
      });
  }
}
